import React from 'react';
import bus from '../assets/mdi--bus.png';
import bank from '../assets/material-symbols--account-balance.png';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const TopupOptions = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
      navigate(path);
    };

  return (
    <div className="flex flex-col h-screen w-full bg-lightest-grey">
      <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
        <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} size="lg" />
        </button>
        <div className="flex items-center justify-center flex-grow gap-2">
          <h1 className="text-gray-600 font-semibold text-lg">
          Topup Options
          </h1>
        </div>
      </nav>

      {/* Main Container */}
      <div className="flex flex-col bg-grey-200 flex-1  pt-2  bg-gray-100">
        {/* OnRide Card */}
        <div className="flex flex-col bg-lightest-grey p-4" onClick={() => handleNavigation('/onRideTopup')}>
          <div className="bg-white shadow-lg rounded-md p-4 flex items-center space-x-4">
            <div className="w-12 h-12 bg-lightest-grey rounded-full p-2 flex items-center justify-center">
              <img src={bus} alt="Bus Icon" className="w-8 h-8 text-red" />
            </div>
            <div>
              <h2 className="text-dark-grey text-lg font-medium">OnRide</h2>
              <p className="text-light-grey text-sm">Through Captains on Ride</p>
            </div>
          </div>
        </div>

        {/* Online Card */}
        <div className="flex flex-col bg-lightest-grey p-4" onClick={() => handleNavigation('/onlineTopup')}>
          <div className="bg-white shadow-lg rounded-md p-4 flex items-center space-x-4">
            <div className="w-12 h-12 bg-lightest-grey rounded-full p-2 flex items-center justify-center">
              <img src={bank} alt="Bank Icon" className="w-8 h-8 text-red" />
            </div>
            <div>
              <h2 className="text-dark-grey text-lg font-medium">Online</h2>
              <p className="text-light-grey text-sm">Online Payment</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopupOptions;
